module.exports = __webpack_public_path__ + "img/number-black-30.92003c18.png";